import React, { useEffect, useState } from 'react';
import './UserPage.css';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import {
  getLoading,
  setSessionloading,
  stopSessionAsync,
  startSessionAsync,
  createUserAsync,
  setUsersLoading,
  deleteUsersAsync,
  updateUsersAsync,
  restoreUserAsync,
} from '../../../features/redux/adminSlice';
import { useSelector } from 'react-redux';
import Confirm from '../../ui/Confirm/Confirm';
import SideSlider from '../../ui/SideSlider/SideSlider';
import { useForm } from 'react-forms-handler';
import validator from 'validator';
import { validateByFieldDynamic } from '../../../utils';
const globals = { users: [] };

function UserPage({ users, roles, applications }) {
  const dispatch = useDispatch();
  const [applicationsOpen, setApplicationsOpen] = useState(null);
  const isLoading = useSelector(getLoading);
  const [filteredUsers, setFilteredUsers] = useState(users);
  const [openForm, setOpenForm] = useState(false);
  const {
    form,
    valid,
    value,
    id,
    name,
    email,
    role_id,
    agent_id,
    application_ids,
  } = useForm({
    id: [''],
    name: ['', (str) => !validator.isEmpty(str)],
    email: [
      '',
      [
        [validator.isEmail, 'Should be valid email!'],
        [
          validateByFieldDynamic(
            () => globals.users.filter((u) => u.id !== id.value),
            'email',
          ),
          'Email exist',
        ],
      ],
    ],
    role_id: [''],
    agent_id: [''],
    application_ids: [''],
  });

  const { serchField } = useForm({
    serchField: [''],
  });

  useEffect(() => {
    if (!application_ids.value) {
      application_ids.value = [];
    }
    if (roles.length > 0) {
      role_id.value = (roles.find((r) => r.name === 'agent') || { id: '' }).id;
    }
  }, [roles, applications]);

  useEffect(() => {
    globals.users = users;
  }, [users]);

  useEffect(() => {
    serchField.stateChange.subscribe((currentValue, prevValue) => {
      setFilteredUsers(
        users.filter((u) =>
          getSerchableText(u)
            .toLowerCase()
            .includes(currentValue.toLowerCase()),
        ),
      );
    });
  }, [serchField]);

  return (
    <div className='users-dashboard-content'>
      <div className='dashboard-header'>
        <h1>Admin Dashboard Users</h1>
        <input
          style={{ width: '20%' }}
          type='text'
          className='form-control'
          {...serchField.inputProps}
          placeholder='Search'
        />
        <button
          className='btn btn-primary'
          onClick={() => {
            setOpenForm(true);
          }}
        >
          Add User
        </button>
      </div>
      <table className='table'>
        <thead className='thead-light'>
          <tr>
            <th scope='col'>#</th>
            <th scope='col'>Name</th>
            <th scope='col'>Role</th>
            <th scope='col'>Email</th>
            <th scope='col'>Active sesion</th>
            <th scope='col'>Total sesion</th>
            <th scope='col'>Created At</th>
            <th scope='col'>Agent Id</th>
            <th scope='col'>Select App</th>
            <th scope='col'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((user, index) => {
            return (
              <tr
                key={`user-${index}`}
                className={`${user.deleted_at ? 'deleted' : ''}`}
              >
                <th scope='row'>{index + 1}</th>
                <td>{user.name}</td>
                <td>{user.role.name}</td>
                <td>{user.email}</td>
                <td>{user.active_sessions}</td>
                <td>{user.total_sessions}</td>
                <td>{moment(user.createdAt).format('MMM Do YY')}</td>
                <td>{user.agent_id}</td>
                <td>
                  {/* {!user.deleted_at && <div className="dropdown">
                                <button  className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" onClick={()=>{setApplicationsOpen(!applicationsOpen ? user.id : null)}}>
                                    Select Application
                                </button>
                                <div className="dropdown-menu" style={{display: applicationsOpen === user.id ? 'block' : 'none'}} >
                                    {user.applications.map((application, i) => {
                                        const activeSession = getActiveSession(sessions, user.id, application.id)
                                        return <a key={`user-application-${i}`} className="dropdown-item"  href="#">
                                          {application.name} 
                                          {!activeSession && <i style={{marginLeft: '4px', cursor: 'pointer'}} 
                                              className={`text-success fa-solid fa-${isLoading.sessions != user.id + application.id ? 'play' : 'circle-notch fa-spin'}`}
                                              onClick={()=>{
                                                if (isLoading.sessions) {
                                                  return;
                                                }
                                                  dispatch(setSessionloading(user.id + application.id))
                                                  dispatch(startSessionAsync({id: application.id, user_id: user.id}))
                                                
                                              }}
                                            ></i>}
                                          {activeSession && <i style={{marginLeft: '4px', cursor: 'pointer'}} 
                                              className={`text-danger fa-solid fa-${isLoading.sessions != activeSession.id ? 'stop' : 'circle-notch fa-spin'}`}
                                              onClick={()=>{
                                                if (isLoading.sessions) {
                                                  return;
                                                }
                                                Confirm.confirm('Are you sure you want to stop application. User might use it right now').then(() => {
                                                  dispatch(setSessionloading(activeSession.id))
                                                  dispatch(stopSessionAsync({session_id: activeSession.id}))
                                                }).catch((e) => {console.log(e)});
                                                
                                              }}
                                            ></i>}
                                        </a>
                                    })}
                                  
                                  
                                </div>
                            </div>} */}
                </td>
                {!user.deleted_at && (
                  <td>
                    <i
                      className={`text-danger fa-solid fa-${isLoading.users != user.id ? 'trash' : 'circle-notch fa-spin'}`}
                      onClick={() => {
                        Confirm.confirm(
                          'Are you sure you want to delete this user? This action can not be undo',
                        )
                          .then(() => {
                            dispatch(setUsersLoading(user.id));
                            dispatch(deleteUsersAsync({ userId: user.id }));
                          })
                          .catch((e) => {
                            console.log(e);
                          });
                      }}
                    ></i>
                    <i
                      style={{ marginLeft: '4px', cursor: 'pointer' }}
                      className={`text-primary fa-solid fa-edit`}
                      onClick={() => {
                        form.clearAllFields();
                        id.value = user.id;
                        name.value = user.name;
                        email.value = user.email;
                        role_id.value = user.role_id;
                        agent_id.value = user.agent_id;
                        application_ids.value = user.applications.map(
                          (a) => a.id,
                        );
                        setOpenForm(true);
                      }}
                    ></i>
                  </td>
                )}
                {user.deleted_at && (
                  <td>
                    <i
                      style={{ cursor: 'pointer' }}
                      className={`text-success fa-solid fa-${isLoading.users != user.id ? 'trash-restore' : 'circle-notch fa-spin'}`}
                      onClick={() => {
                        Confirm.confirm(
                          'Are you sure you want to restore this user?',
                        )
                          .then(() => {
                            dispatch(setUsersLoading(user.id));
                            dispatch(restoreUserAsync(user));
                          })
                          .catch((e) => {
                            console.log(e);
                          });
                      }}
                    ></i>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      <SideSlider open={openForm}>
        <i
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            cursor: 'pointer',
          }}
          className={`text-primary fa-solid fa-rectangle-xmark`}
          onClick={() => {
            setOpenForm(false);
            form.clearAllFields();
          }}
        ></i>
        <form style={{ textAlign: 'left' }}>
          <div className='form-group'>
            <label>Name</label>
            <input
              type='text'
              {...name.inputProps}
              className='form-control'
              id='exampleInputPassword1'
              placeholder='Enter name'
            />
            {name.touched && !name.valid && (
              <small id='emailHelp' className='form-text text-danger '>
                Should be valid email!
              </small>
            )}
          </div>
          <div className='form-group'>
            <label>Email</label>
            <input
              type='text'
              {...email.inputProps}
              className='form-control'
              id='exampleInputEmail1'
              aria-describedby='emailHelp'
              placeholder='Enter email'
            />
            {email.touched && email.errors && (
              <small id='emailHelp' className='form-text text-danger '>
                {email.errors}
              </small>
            )}
          </div>
          <div className='form-group'>
            <label>Agent Id</label>
            <input
              type='text'
              {...agent_id.inputProps}
              className='form-control'
              id='exampleInputAgentId'
              aria-describedby='emailHelp'
              placeholder='Enter Agent Id'
            />
            {agent_id.touched && agent_id.errors && (
              <small id='emailHelp' className='form-text text-danger '>
                {agent_id.errors}
              </small>
            )}
          </div>
          <div className='form-group'>
            <label>Role</label>
            <select className='form-control' {...role_id.inputProps}>
              {roles.map((role, index) => {
                return (
                  <option key={`role-${index}`} value={role.id}>
                    {role.name}
                  </option>
                );
              })}
            </select>
          </div>
          <div className='form-group'>
            <label>Applications</label>
            <select
              className='form-control'
              multiple
              {...application_ids.inputProps}
              onChange={(e) => {
                application_ids.value = Array.from(
                  e.target.selectedOptions,
                ).map((o) => o.value);
              }}
            >
              {applications.map((application, index) => {
                return (
                  <option
                    key={`add-user-application-${index}`}
                    value={application.id}
                  >
                    {application.name}
                  </option>
                );
              })}
            </select>
          </div>

          <button
            disabled={!valid || isLoading.users}
            type='submit'
            className='btn btn-primary'
            onClick={(e) => {
              if (id.value) {
                dispatch(updateUsersAsync(value));
              } else {
                dispatch(createUserAsync(value));
              }
              setOpenForm(false);
              form.clearAllFields();
              e.preventDefault();
            }}
          >
            Submit
          </button>
        </form>
      </SideSlider>
    </div>
  );
}

function getActiveSession(sessions, user_id, application_id) {
  return sessions.find(
    (s) =>
      s.user_id === user_id &&
      s.application_id === application_id &&
      !s.end_date,
  );
}
export default UserPage;

function getSerchableText(user) {
  return `${user.name}${user.role.name}${user.email}${user.active_sessions}${user.total_sessions}${moment(user.createdAt).format('MMM Do YY')}`;
}
